'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollParent;
var DEFAULT_SCROLL_PARENT = 'BODY';

function isScrollParent(element) {
  try {
    var _window$getComputedSt = window.getComputedStyle(element),
        overflow = _window$getComputedSt.overflow,
        overflowY = _window$getComputedSt.overflowY,
        overflowX = _window$getComputedSt.overflowX;

    return (/(auto|scroll)/.test(overflow + overflowX + overflowY)
    );
  } catch (e) {
    return false;
  }
}

function getScrollParent(element) {
  if (isScrollParent(element)) {
    return element;
  } else if (element.tagName === DEFAULT_SCROLL_PARENT) {
    return element;
  } else {
    return getScrollParent(element.parentNode);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/scroll-parent/lib/getScrollParent.js
// module id = 1095
// module chunks = 0